import styled from 'styled-components'

export const Title = styled.h2`
  font-weight: 600;
`

export const Section = styled.section`
  display: flex;
  justify-content: space-around;
  padding: 1rem 0rem 1rem;
  max-width: 1250px;
  flex: 1;
  flex-direction: column;
`

export const WrapperSection = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 0;
  max-width: 1250px;
`

export const Label = styled.label`
  display: flex;
  font-size: 1.2rem;
  font-weight: bold;
  flex: 1;
  padding: 0 1rem;
`

export const SubLabel1 = styled.label`
  display: flex;
  font-size: 1.2rem;
  font-weight: bold;
  flex: 1;
  padding: 0 1rem;
  margin-left: 1.5rem;
`

export const SubLabel2 = styled.label`
  display: flex;
  font-size: 1.2rem;
  font-weight: bold;
  flex: 1;
  padding: 0 1rem;
  margin-left: 3rem;
`

export const Text = styled.p`
  line-height: inherit;
  font-size: inherit;
  margin: 0 0 0 0.2rem;
  font-weight: normal;
`

interface ButtonProps {
  width?: number
  height?: number
  color?: string
  hoverColor?: string
}

export const Button = styled.button<ButtonProps>`
  outline-color: #002d63;
  width: ${({ width = 6 }) => `${width}rem`};
  height: ${({ height = 2.5 }) => `${height}rem`};
  border: 1px solid #c7c9c7;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled, color = '#002962' }) => (disabled ? '#bbbbbb' : color)};
  font-weight: bold;
  text-align: center;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    transition: 200ms ease-in-out;
    background-color: ${({ hoverColor = '#3079d1' }) => hoverColor} ;
  }
`

export const Select = styled.select`
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  height: 2.5rem;
  width: 16rem;
  &:hover {
    cursor: pointer;
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #2962ff;
  }
`

export const Option = styled.option`
  width: 100%;
`
